module.exports = __webpack_public_path__ + "img/card-information.a7aec88e.png";